import Vue from 'vue'
import App from './App.vue'
import store from '@/store'

import 'amfe-flexible'

import './assets/common.less'
import './assets/iconfont.less'

import dataV from '@jiaminghi/data-view'

import utils from './utils/utils.js'

Vue.config.productionTip = false
Vue.prototype.$utils = utils
Vue.prototype.$store = store

Vue.use(dataV)

new Vue({
  render: h => h(App)
}).$mount('#app')
